import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import { CountryCode } from '../../app/shared/country-code';
import { Location } from '@angular/common';

@Component({
  selector: 'app-edit-customer',
  templateUrl: './edit-customer.component.html',
  styleUrls: ['./edit-customer.component.css']
})
export class EditCustomerComponent implements OnInit {

  constructor(private customerService:ServiceService,
    private route: ActivatedRoute,
     private router: Router
    ,private location : Location) { }

  output:any=[]; //---store get() result--------
  customerId='';
  //getUrl='http://192.241.151.66:5000/viewCustomers';
  //putUrl='http://192.241.151.66:5000/updateCustomers';
  //deptUrl='http://192.241.151.66:5000/viewDepartments/department_dropdown'
  //empUrl='http://192.241.151.66:5000/viewEmployees';
  country: any [] = CountryCode
  data:any={}
  alert="";
  department:any=[];
  dept:any=[];
  employee:any=[];
  emp1:any=[];
  isShown: boolean = false;
  EmailAlert=""
  email:any=new FormControl('', [Validators.required, Validators.email]);
  
 //--------function for shown the alert----------
 shown(){
  this.isShown=false
}
//for showing notifivation
notification(){
  this.isShown = !this.isShown;
}
//for getting id of selected department
onSelected(value:any): void {
  this.data.customer_department_id = value;
  //-------api get()calling for dept name of carrasponding id-------------
  this.customerService.ViewDepartmentID(value).subscribe((res)=>{
    this.dept=res.data;
  this.data.customer_department=this.dept[0].department_name;
  console.log("dept after=",this.data.department_id);
  console.log("dept after=",this.dept[0].department_name);
  })
}
//-------for getting name of selected  responsible employee id----
onSelectedEmployee1(value:string): void {
  this.data.responsible = value;
  this.customerService.ViewEmployeeById('/'+value).subscribe((res)=>{
    this.emp1=res.data;
  this.data.responsible_name=this.emp1[0].employee_name;
  console.log("res id after=",this.data.responsible);
  })
}

//-------for getting name of selected   second responsible employee id----
onSelectedEmployee2(value:string): void {
  this.data.second_responsible= value;
  this.customerService.ViewEmployeeById('/'+value).subscribe((res)=>{
    this.emp1=res.data;
  this.data.second_responsible_name=this.emp1[0].employee_name;
  console.log("second id after=",this.data.responsible);
  })
}

//-------for getting name of sales executive id------------
onSelectedEmployee3(value:string): void {
  this.data.sales_executive = value;
  this.customerService.ViewEmployeeById('/'+value).subscribe((res)=>{
    this.emp1=res.data;
  this.data.sales_executive_name=this.emp1[0].employee_name;
  console.log("res id after=",this.data.responsible);
  })
}
//---------check value changes in the text box----
valuechange1(newValue1: any) {
  this.data.name=newValue1
  this.EmailAlert=""
  }
  codeValid:string =''
btnClick()
{
  if(this.data.customer_email!=" " && this.data.customer_email!="")
    {
      console.log("hai")
      if (this.email.invalid)
      {
        this.EmailAlert="invalid email id"
        this.alert="Invalid data"
        return
      }
    }
    if(this.data.customer_email=="")
    {
      this.data.customer_email=" "

      console.log("no email",this.data.email_address)

    }
    if(this.data.customer_mobile != ''){
      if(this.data.customer_country_code == '' || this.data.customer_country_code == undefined){
        this.codeValid = 'Enter country code'
        return
      }
    }
  //--------api for put----------//
  if(this.data.customer_country_code){
    this.data.customer_mobile = this.data.customer_country_code + this.data.customer_mobile
  }
  // debugger
  // return
  this.customerService.UpdateCustomers(this.data).subscribe((res) => {
    console.log("name=",this.data.C_name);
    this.alert=res.message;
    this.notification();
    if(res.message == 'Succesfully updated Customer list'){
      setTimeout(() => {
        this.location.back()
      }, 1000);
    }
    // this.location.back()
    console.log("res=",this.alert);

  })
}
  ngOnInit(): void {
    this.subInput('')
     //---call function in service for employee Id------
     this.customerId=this.customerService.getCustomerId()
     console.log("employee id=",this.customerId)

    //-------api get()calling-------------
    this.customerService.CutomerDetails('/'+this.customerId).subscribe((res)=>{
      this.output=res.data
      console.log("cc name=",this.output[0].customer_name)

      this.data={
        customer_id:this.output[0].customer_id,
        customer_name:this.output[0].customer_name,
        customer_code:this.output[0].customer_code,
        customer_email:this.output[0].customer_email,
        customer_department:this.output[0].customer_department,
        credit_limit:this.output[0].credit_limit,
        credit_balance:this.output[0].credit_balance,
        earliest_overdue_date:this.output[0].earliest_overdue_date,
        oldest_due_inv_date:this.output[0].oldest_due_inv_date,
        oldest_due_inv_number:this.output[0].oldest_due_inv_number,
        contract:this.output[0].contract,
        company_price:this.output[0].company_price,
        payment_terms:this.output[0].payment_terms,
        current_month_sales:this.output[0].current_month_sales,
        last_3_month_sales:this.output[0].last_3_month_sales,
        customer_department_id:this.output[0].customer_department_id,
        responsible:this.output[0].responsible,
        responsible_name:this.output[0].responsible_name,

        second_responsible:this.output[0].second_responsible,
        second_responsible_name:this.output[0].second_responsible_name,
        sales_executive:this.output[0].sales_executive,
        sales_executive_name:this.output[0].sales_executive_name,
        customer_mobile: this.output[0].customer_mobile,
        customer_country_code: this.output[0].customer_country_code
      }
      // this.MobileNumber = this.data.customer_mobile
      if(this.data.customer_country_code){
        this.data.customer_mobile = this.data.customer_mobile.replace(this.data.customer_country_code,'')
      }
      // debugger
     console.log("dept before",this.data.customer_department_id)
    })
      //-------api for get department name---------

      this.customerService.ViewDepartment("").subscribe((res)=>{
        this.department=res.data
        console.log("Department details at employee edit =",this.department)
  
      })

      //-------api for get emoployee name---------

      this.customerService.ViewEmployee().subscribe((res)=>{
        this.employee=res.data
  
      })
  }

/////////////////////////////////////////////////////////////////////////

 subinputFocused: string = ''
  subinputFocusedmain: string = ''
  // customer_country_code:string = ''

  subInput(value: string) {
    if (value == 'focus') {
      this.subinputFocused = 'subinputFocused'
      this.subinputFocusedmain = 'subinputFocusedmain'
    }
    else {
      this.subinputFocused = 'generic-input-submain'
      this.subinputFocusedmain = ''
    }
  }

  countryCodeappend:string=''
  // MobileNumber:string=''
  countryCode(value:any){
    // this.customer_country_code = value
    this.data.customer_country_code = value
    // this.MobileNumber = this.MobileNumber.replace(value, '');
  }
  mobileNumbercustomer(value:any){
    console.log(value);
    this.data.customer_mobile = value
    
  }


  
}
